import type {
  Ability,
  AbilityConditions,
  Actions,
  Subjects,
} from '@cast/shared-ability-data-access';

export type SidebarNavRules = Array<[Actions, Subjects]>;

export const canViewNavItem = (
  ability: Pick<Ability, 'canMany'>,
  rules?: SidebarNavRules,
  conditions?: AbilityConditions
): boolean => {
  if (!rules?.length) {
    return true;
  }

  return ability.canMany(rules, conditions).every(Boolean);
};
